import { render, staticRenderFns } from "./AdminSettingsView.vue?vue&type=template&id=56a33ec5&scoped=true"
import script from "./AdminSettingsView.vue?vue&type=script&lang=js"
export * from "./AdminSettingsView.vue?vue&type=script&lang=js"
import style0 from "./AdminSettingsView.vue?vue&type=style&index=0&id=56a33ec5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a33ec5",
  null
  
)

export default component.exports